import { EnvEnum } from '../types/env.enum';

// -----------------------------------------------------------------------------
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class ConfigService {
  // #region general
  // ---------------------------------------------------------------------------
  static getApiUrl(): string {
    return this.getString('VITE_API_URL');
  }

  // ---------------------------------------------------------------------------
  static getSecondaryApiUrl(): string {
    return this.getString('VITE_SECONDARY_API_URL');
  }

  // ---------------------------------------------------------------------------
  static getEnvironment(): EnvEnum {
    const env = this.getString('VITE_ENV').toLowerCase();
    if (env === 'development') {
      return EnvEnum.Development;
    }

    if (env === 'testing') {
      return EnvEnum.Testing;
    }

    if (env === 'staging') {
      return EnvEnum.Staging;
    }

    if (env === 'production') {
      return EnvEnum.Production;
    }

    throw new Error('Invalid environment');
  }

  // ---------------------------------------------------------------------------
  static getCommitHash(): string {
    return this.getString('VITE_COMMIT_HASH');
  }

  // ---------------------------------------------------------------------------
  static getRecaptchaSiteKey(): string {
    return this.getString('VITE_RECAPTCHA_SITE_KEY');
  }

  // #endregion

  // #region sentry
  // ---------------------------------------------------------------------------
  static getSentryDsn(): string {
    return this.getString('VITE_SENTRY_DSN');
  }

  // #endregion

  // #region medplum
  // ---------------------------------------------------------------------------
  static getClientId(): string {
    return this.getString('VITE_CLIENT_ID');
  }

  // ---------------------------------------------------------------------------
  static getClientSecret(): string {
    return this.getString('VITE_CLIENT_SECRET');
  }

  // #endregion

  // #region private
  // ---------------------------------------------------------------------------
  private static getString(key: string): string {
    return this.getKey(key);
  }

  // ---------------------------------------------------------------------------
  private static getNumber(key: string): number {
    return Number(this.getKey(key));
  }

  // ---------------------------------------------------------------------------
  private static getBoolean(key: string): boolean {
    return this.getKey(key) === 'true';
  }

  // ---------------------------------------------------------------------------
  private static getKey(key: string): string {
    const value = import.meta.env[key];
    if (!value) {
      throw new Error(`Missing environment variable: ${key}`);
    }

    return value;
  }

  // #endregion
}
